<template>
    <el-card class="full-width" :body-style="{padding: 0}" v-loading="loading">
        <div class="header-part">
            <div class="product-name">
                <span>{{item.productname}}</span>
            </div>

            <div class="pruduct-id">
                <span>{{item.productid}}</span>
            </div>

            <div class="img-part">
                <div class="img-box">
                    <img class="product-img" :src="imgUrl">
                </div>
            </div>

        </div>

        <div class="operation-box">
            <div class="price-div">
                <span><span class="price-title-span" tkey="銷售價">{{i18n.tkey("lang_selling_price")}}</span>：<span class="price-span">{{item.cost}} {{item.curr}} {{unitSpan}}</span></span>
            </div>

            <div style="margin-top: 10px">
                <el-button type="primary" @click="clickEdit">
                    <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                </el-button>
                <el-button type="danger" @click="clickDelete">
                    <font-awesome-icon icon="fa-solid fa-trash" />
                </el-button>
            </div>
        </div>

    </el-card>
</template>

<script setup>
    import {toRef, ref, onMounted, computed, onUnmounted, inject} from "vue";
    import { useUserinfo } from '@/stores/userinfo'
    import myUtil from "@/util/util";
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faTrash, faPenToSquare } from '@fortawesome/free-solid-svg-icons'

    library.add(faTrash, faPenToSquare)

    const props = defineProps(['item'])
    const emits = defineEmits(['clickDelete', 'clickEdit'])

    const userInfoRef = toRef(useUserinfo())

    const i18n = inject("i18n")
    const imgUrl = ref(null)

    const loading = ref(false)

    const unitSpan = computed(() => {
        if (null != props.item && null != props.item.unit){
            return `/${props.item.unit}`
        }

        return ""
    })

    function clickDelete(){
        myUtil.confirmWarning(i18n.tkey("lang_del_confirm"), () => {
            emits("clickDelete", props.item)
        })
    }

    function clickEdit(){
        emits("clickEdit", props.item)
    }

    onMounted(() => {
        if (null != props.item){
            imgUrl.value = myUtil.generateProductImg(props.item)
        }
    })

    onUnmounted(() => {

    })
</script>

<style scoped>
    .full-width-item {
        width: 100%;
        box-sizing: border-box;

    }

    .header-part {
        background: linear-gradient(45deg, #708090, #7c8ea0) !important;
        color: #fff !important;
    }

    .img-part {
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
    }

    .img-box {
        width: 100%;
        padding-top: 100%;
        position: relative;
    }

    .product-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        box-sizing: border-box;
        border: 1px #F2F6FC solid;
    }

    .product-name {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 14px;
        padding-left: 5px;
        padding-right: 5px;
        line-height: 2;
        text-align: center;
    }

    .pruduct-id {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 12px;
        padding-left: 5px;
        padding-right: 5px;
        line-height: 1.5;
    }

    .operation-box {
        padding: 20px;
        padding-top: 5px;
    }

    .price-title-span {
        color: #909399;
        font-size: 12px;
    }

    .price-span {
        color: #e83f33;
        font-size: 14px;
    }

    .price-div {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
    }
</style>